import { FETCH_FEATURED_PRODUCTS } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case FETCH_FEATURED_PRODUCTS:
      return { ...state, data: action.payload.data };
    default:
      return state;
  }
};
